/**
 * Minimal school-config shim for Topwin ziwei-web-app.
 * Upstream file also persists UI preferences via localStorage; we only need the
 * leap-month default used by generateChart().
 *
 * Source: Renhuai123/ziwei-doushu (MIT) — lib/ziwei/school-config.ts
 */
export type LeapMonth = 'split' | 'next-month' | 'prev-month' | 'origin-month';

/** 主流排盘默认口径「月中分界」 */
export const DEFAULT_LEAP_MONTH: LeapMonth = 'split';
